import PropTypes from 'prop-types';
import React from 'react';
import { shouldUpdate } from 'recompose';
import { t } from '../../../../../modules/infra/i18n';
import { getChange, getShrinkage } from './utils';

const ProductItem = ({ product, actualInventoryValue, onInputChange, style }) => {
  return (
    <div className="rt-tr-group" style={style}>
      <div className="rt-tr">
        <div className="rt-td u-flex-1">{product.name}</div>
        <div className="rt-td c-table-column__width-150">{product.inventory}</div>
        <div className="rt-td c-table-column__width-150">
          <input
            type="number"
            className="c-input"
            id={product.assignmentId}
            name={product.assignmentId}
            placeholder={t('products:bulk_inventory.actual_inventory_button')}
            value={actualInventoryValue}
            onChange={onInputChange}
            onWheel={(e) => e.target.blur()}
          />
        </div>
        <div className="rt-td c-table-column__width-150">{getChange(product, actualInventoryValue)}</div>
        <div className="rt-td c-table-column__width-150">{getShrinkage(product, actualInventoryValue)}</div>
      </div>
    </div>
  );
};

ProductItem.propTypes = {
  style: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  actualInventoryValue: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

ProductItem.defaultProps = {
  actualInventoryValue: null,
};

const enhance = shouldUpdate((props, nextProps) => props.actualInventoryValue !== nextProps.actualInventoryValue);

export default enhance(ProductItem);
